import { isNotNullOrUndefined } from "common/data-util";
import { ConditionalComponentWrapper } from "components/common/ConditionalComponentWrapper";
import { ChargingAgreementPricing, ChargingPurchaseOption, ChargingPurchaseOptionType } from "models/charging/agreement";
import React from "react"

interface NewChargingAgreementDeviceCardProps {
  address?: string;
  purchaseOption: ChargingPurchaseOption;
  pricing: ChargingAgreementPricing;
}

export function NewChargingAgreementDeviceCard({
  address,
  purchaseOption,
  pricing
} : NewChargingAgreementDeviceCardProps ){

  const showBasicRent = purchaseOption.type === ChargingPurchaseOptionType.RENT && 
    isNotNullOrUndefined(pricing.devicesRentalMonthlyFeeEuros);
  const showFullServiceRent = purchaseOption.type === ChargingPurchaseOptionType.FULL_SERVICE_RENT && 
    isNotNullOrUndefined(pricing.devicesFullServiceRentalMonthlyFeeEuros);

  const showVatLabel = isNotNullOrUndefined(pricing.installationFeeEuros) || isNotNullOrUndefined(pricing.maintenanceMonthlyFeeEuros) || 
    isNotNullOrUndefined(pricing.devicesCostEuros) || showBasicRent || showFullServiceRent;

  return (
    <div className="d-lg-flex justify-content-between align-items-center u-fs-16">
      <div className="d-flex flex-column flex-1">
          <div>
              <h2 className="mb-1">{purchaseOption.name}</h2>
              <p className="mb-1">{purchaseOption.description}</p>
          </div>
          {
            showVatLabel ? (
             <>
                <div className="row mt-1">
                    <div className="col">
                        <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.installationFeeEuros)} className="row">
                            <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Seadmete paigaldustasu:</div>
                            <div className="font-weight-bold">{pricing.installationFeeEuros} €</div>
                        </ConditionalComponentWrapper>     
                        <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.maintenanceMonthlyFeeEuros)} className="row">
                          <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Seadmete hoolduse kuutasu:</div>
                          <div className="font-weight-bold">{pricing.maintenanceMonthlyFeeEuros} €</div>
                        </ConditionalComponentWrapper>    
                        <ConditionalComponentWrapper condition={showBasicRent} className="row">
                          <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Seadmete rendi kuutasu:</div>
                          <div className="font-weight-bold">{pricing.devicesRentalMonthlyFeeEuros} €</div>
                        </ConditionalComponentWrapper>    
                        <ConditionalComponentWrapper condition={showFullServiceRent} className="row">
                          <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Seadmete täisteenusrendi kuutasu:</div>
                          <div className="font-weight-bold">{pricing.devicesFullServiceRentalMonthlyFeeEuros} €</div>
                        </ConditionalComponentWrapper>    
                        <ConditionalComponentWrapper condition={isNotNullOrUndefined(pricing.devicesCostEuros)} className="row">
                          <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Seadmete maksumus:</div>
                          <div className="font-weight-bold">{pricing.devicesCostEuros} €</div>
                        </ConditionalComponentWrapper>   
                        <ConditionalComponentWrapper condition={showVatLabel} className="row mt-2">
                          <div className="col text-gray-700 u-fs-14">
                            Hindadele lisandub käibemaks
                          </div>
                        </ConditionalComponentWrapper>                
                    </div>
                </div>
             </>
            ) : null
          }
          <ConditionalComponentWrapper condition={isNotNullOrUndefined(address)} className="col p-0 d-flex mt-3">
            <div className="text-gray-700 u-fs-14 mr-2">Aadress:</div>
            <div className="font-weight-bold">{address}</div>
          </ConditionalComponentWrapper>   
      </div>
  </div>
  );
}